module.exports = __webpack_public_path__ + "assets/img/greece.0576e716.png";